<div class="tag-selector" [class.tag-selector--open]="isOpen">
  <div class="tag-selector-wrapper">
    <div class="tag-select-button" (click)="toggleDropdown()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
      <span class="placeholder" *ngIf="selectedTagIds.length === 0">{{ placeholder | translate }}</span>
      <div class="selected-tags-list" *ngIf="selectedTagIds.length > 0">
        <span *ngFor="let id of selectedTagIds" class="tag-chip">
          {{ getTagName(id) }}
          <i class="pi pi-times chip-remove" (click)="removeTag(id, $event)"></i>
        </span>
      </div>
      <i class="pi" [ngClass]="isOpen ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
    </div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen"
      [cdkConnectedOverlayMinWidth]="triggerWidth" (backdropClick)="isOpen = false" (detach)="isOpen = false"
      [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'">
      <div class="tag-dropdown overlay-dropdown" (click)="$event.stopPropagation()">
        <div class="tag-search">
          <input type="text" [(ngModel)]="searchTerm" [placeholder]="'Search...' | translate"
            class="tag-search-input" />
          <button
            type="button"
            class="tag-create-btn"
            [pTooltip]="('UPLOAD_IMAGES.MODAL_TAGS_CREATE_TOOLTIP' | translate) || ''"
            tooltipPosition="top"
            *ngIf="canShowCreateButton()"
            (click)="openCreateModal($event)"
          >
            {{ 'UPLOAD_IMAGES.MODAL_TAGS_CREATE' | translate }}
          </button>
        </div>
        <div class="tag-list">
          <div class="tag-item" *ngFor="let tag of filteredTags" [class.tag-item--selected]="isSelected(tag.id)"
            (click)="toggleTag(tag.id, $event)">
            <i class="pi" [ngClass]="isSelected(tag.id) ? 'pi-check' : ''"></i>
            <span>{{ tag.name }}</span>
          </div>
          <div class="tag-empty" *ngIf="filteredTags.length === 0 && !searchTerm.trim()">
            {{ 'No tags found' | translate }}
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<app-tag-modal
  [visible]="isCreateModalOpen"
  (visibleChange)="isCreateModalOpen = $event"
  [mode]="'create'"
  [initialName]="createModalInitialName"
  [existingTags]="existingTags"
  [disableVisibilityControls]="true"
  (saved)="handleModalSaved($event)"
></app-tag-modal>
